const state = {
    files: [],
    fileId: [],
    loading: false
};

export default state;